<template>
  <div
    :ref="containerID"
    class="app-file-selector"
    :class="{ error, disabled }"
  >
    <label :for="refName">
      <gallery-icon />
      <span>Select a file {{ test }} </span>
      <input
        :id="refName"
        :name="refName"
        :ref="refName"
        :accept="accept"
        type="file"
        style="display: none"
        @input="inputImageRenderer"
        @click="handleReset"
      />
    </label>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useInputImageRenderer } from '@core/composables/forms/form-utils'
import { useDropZone } from '@vueuse/core'
import { toBase64 } from '@core/utils/helpers'
import GalleryIcon from '@/assets/svg/gallery.svg?component'

export default defineComponent({
  components: {
    GalleryIcon,
  },
  emits: ['update:file', 'update:fileContent'],
  props: {
    accept: String,
    refName: String,
    error: Boolean,
    disabled: Boolean,
  },

  data() {
    const containerID = btoa(Math.random().toString()).substring(10, 15)

    return {
      containerID,
    }
  },

  mounted() {
    const { inputImageRenderer } = useInputImageRenderer(
      { value: this.$refs[this.refName] },
      (loadedFile, base64) => {
        this.extendLoadedFileWithBase64(loadedFile, base64)
        this.emit(loadedFile, base64)
      }
    )
    this.inputImageRenderer = inputImageRenderer

    useDropZone(this.$refs[this.containerID], this.onDrop)
  },
  methods: {
    handleReset(event) {
      event.target.value = null
    },
    async onDrop([loadedFile]) {
      const base64 = await toBase64(loadedFile)

      this.extendLoadedFileWithBase64(loadedFile, base64)
      this.emit(loadedFile, base64)
    },
    extendLoadedFileWithBase64(loadedFile, base64) {
      Object.defineProperty(loadedFile, 'fileContent', {
        value: base64,
        writable: false,
      })
    },
    emit(loadedFile, base64) {
      this.$emit('update:file', loadedFile)
      this.$emit('update:fileContent', base64)
    },
  },
})
</script>
